var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBronze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 26,
    viewBox: "0 0 62 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 61,
    height: 26,
    rx: 13,
    fill: "url(#paint0_linear_1569_48359)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.424 17H14.952C16.932 17 17.964 16.172 17.964 14.6V14.552C17.964 13.4 17.364 12.764 16.248 12.536C17.208 12.26 17.64 11.6 17.64 10.7V10.652C17.64 9.188 16.668 8.42 14.796 8.42H11.424V17ZM13.32 15.656V13.196H14.556C15.612 13.196 16.044 13.604 16.044 14.396V14.444C16.044 15.224 15.612 15.656 14.652 15.656H13.32ZM13.32 11.948V9.752H14.472C15.384 9.752 15.792 10.076 15.792 10.796V10.844C15.792 11.612 15.42 11.948 14.484 11.948H13.32ZM19.1782 17H20.9182V13.856C20.9182 12.656 21.6622 12.236 22.9462 12.248V10.628C21.9262 10.64 21.3142 11.084 20.9182 11.924V10.724H19.1782V17ZM26.8991 15.812C25.9151 15.812 25.3631 15.092 25.3631 13.892V13.796C25.3631 12.596 25.9391 11.9 26.8991 11.9C27.8711 11.9 28.4351 12.62 28.4351 13.82V13.904C28.4351 15.092 27.8711 15.812 26.8991 15.812ZM26.8871 17.132C28.7711 17.132 30.1991 15.872 30.1991 13.892V13.796C30.1991 11.84 28.7831 10.58 26.8991 10.58C25.0151 10.58 23.5871 11.864 23.5871 13.832V13.928C23.5871 15.884 25.0151 17.132 26.8871 17.132ZM31.3657 17H33.1057V13.376C33.1057 12.452 33.6697 11.996 34.4137 11.996C35.1817 11.996 35.5177 12.404 35.5177 13.256V17H37.2577V13.004C37.2577 11.324 36.3817 10.58 35.1457 10.58C34.1017 10.58 33.4177 11.096 33.1057 11.72V10.724H31.3657V17ZM38.1485 17H43.6445V15.656H40.6445L43.7645 10.94V10.724H38.4605V12.068H41.2445L38.1485 16.808V17ZM47.5702 17.132C49.2862 17.132 50.3662 16.376 50.5702 15.02H48.9262C48.8182 15.548 48.4222 15.896 47.6182 15.896C46.6702 15.896 46.1062 15.296 46.0582 14.252H50.5822V13.772C50.5822 11.528 49.1422 10.58 47.5222 10.58C45.6982 10.58 44.2942 11.864 44.2942 13.844V13.94C44.2942 15.944 45.6742 17.132 47.5702 17.132ZM46.0822 13.184C46.2142 12.296 46.7422 11.78 47.5222 11.78C48.3502 11.78 48.8302 12.236 48.8902 13.184H46.0822Z",
    fill: "#0B0B0C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1569_48359",
    x1: 0.5,
    y1: 0,
    x2: 60.6043,
    y2: 28.4349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE5F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.400005,
    stopColor: "#F7BE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76629,
    stopColor: "#D28A47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDA767"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronze);
export default __webpack_public_path__ + "static/media/bronze.61ddcc3eca2b05066f094085293a2c15.svg";
export { ForwardRef as ReactComponent };